import { Factory, HeartPulse, Cpu, GraduationCap, Hotel, ShoppingBag, Truck, Briefcase, HardHat } from "lucide-react";

export const industries = [
  {
    slug: "manufacturing",
    icon: Factory,
    name: "Manufacturing",
    challenge: "Shift-based operations, thousands of shop-floor workers, biometric complexity, and strict compliance rules.",
    solution: "ClockedIn unifies biometric devices, shift rosters, and attendance-linked payroll into a single reliable system built for high-volume workforces.",
    modules: ["Attendance", "Shift Scheduling", "Payroll", "Reports"],
    roi: "Cut payroll errors by up to 92% and close monthly payroll in under a day.",
  },
  {
    slug: "healthcare",
    icon: HeartPulse,
    name: "Healthcare",
    challenge: "24/7 rotating shifts, credential compliance, and rapid onboarding of nurses, doctors, and support staff.",
    solution: "Automated shift management, credential-aware documents, and mobile self-service keep clinical staff productive and compliant.",
    modules: ["Shift Scheduling", "Documents", "Employee Self Service", "Security"],
    roi: "Reduce scheduling gaps by 60% and eliminate credential lapses.",
  },
  {
    slug: "it-services",
    icon: Cpu,
    name: "IT & Software",
    challenge: "Distributed teams, hybrid work, region-specific leave policies, and rapid hiring cycles.",
    solution: "A flexible rules engine plus mobile self-service supports every work model — from remote engineers to office-first project teams.",
    modules: ["Leave", "Self Service", "Mobile", "Reports"],
    roi: "Cut HR queries by 70% and speed up onboarding by 3x.",
  },
  {
    slug: "schools",
    icon: GraduationCap,
    name: "Schools & Education",
    challenge: "Academic-calendar-driven leave, staff credentials, and multi-campus HR administration.",
    solution: "Configure academic leave policies, manage teaching and non-teaching staff separately, and automate payroll across campuses.",
    modules: ["Leave", "Payroll", "Employee Management", "Documents"],
    roi: "Save 20+ HR hours per campus per month.",
  },
  {
    slug: "hotels",
    icon: Hotel,
    name: "Hotels & Hospitality",
    challenge: "Seasonal hiring, split shifts, tip and allowance management, and multi-property operations.",
    solution: "Handle rotating shifts, custom allowances, and mobile punch across every property from one console.",
    modules: ["Shift Scheduling", "Payroll", "Mobile", "Attendance"],
    roi: "Increase workforce utilization by 15%.",
  },
  {
    slug: "retail",
    icon: ShoppingBag,
    name: "Retail",
    challenge: "High attrition, part-time staff, and store-level attendance tracking with tight labor cost controls.",
    solution: "Store-level dashboards, mobile onboarding, and daily labor cost reports give retail leaders real-time control.",
    modules: ["Attendance", "Payroll", "Reports", "Mobile"],
    roi: "Trim labor cost by 4-6% with daily insights.",
  },
  {
    slug: "logistics",
    icon: Truck,
    name: "Logistics",
    challenge: "Field workforce across geographies, GPS-verified attendance, and multi-hub operations.",
    solution: "Beacon-based punches, GPS attendance, and mobile approvals keep drivers and hub staff accurately tracked.",
    modules: ["Mobile", "Attendance", "Approvals", "Reports"],
    roi: "Eliminate 100% of manual driver timesheets.",
  },
  {
    slug: "professional-services",
    icon: Briefcase,
    name: "Professional Services",
    challenge: "Client-driven schedules, timesheet accuracy, and utilization reporting for billable staff.",
    solution: "Modern timesheets, custom allowances by engagement, and analytics-grade utilization reports.",
    modules: ["Reports", "Payroll", "Employee Management", "Approvals"],
    roi: "Increase billable utilization by 8%.",
  },
  {
    slug: "construction",
    icon: HardHat,
    name: "Construction",
    challenge: "Site-based workforce, safety compliance, and multi-project attendance tracking.",
    solution: "GPS punches, site rosters, and mobile approvals connect every job site to the head office.",
    modules: ["Mobile", "Attendance", "Documents", "Reports"],
    roi: "Reduce ghost worker payments by 100%.",
  },
];
